import dayjs from "dayjs";

export const dayjsFormatDate = (dateToFormat: any, formatType: any) =>
  dayjs(dateToFormat).format(formatType);
